export default __webpack_public_path__ + "static/media/icon_1.bbc09ae7.png";